import { Component, OnDestroy, OnInit, signal, inject } from '@angular/core';
import { TrainingNavComponent } from '../training-nav/training-nav.component';
import { TrainingService } from '../training.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { TrainingSectionComponent } from '../training-section/training-section.component';
import { NgxLoadingModule } from 'ngx-loading';

@Component({
  selector: 'app-training-flow',
  templateUrl: './training-flow.component.html',
  styleUrl: './training-flow.component.scss',
  imports: [
    TrainingNavComponent,
    TrainingSectionComponent,
    MatExpansionModule,
    NgxLoadingModule,
  ],
})
export class TrainingFlowComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private trainSvc = inject(TrainingService);
  private ss = inject(SessionStorageService);

  currentTab = 'landing';
  currentMode = 'landing';
  courseData = {
    app: null,
    curriculum: null,
    title: null,
    description: null,
    videoCode: null,
  };
  app: string;
  appSignal = signal(null);
  trainingData = this.ss.get('training');
  settings: any;
  unsubscribe = new Subject();
  loading: boolean;
  videoMode: boolean;
  loadedVideo: any;

  ngOnInit(): void {
    this.loading = true;
    this.route.params?.subscribe(currParams => {
      if (currParams.app) {
        this.trainSvc.setApp(currParams.app);
        this.videoMode = false;
        this.loadedVideo = null;
        if (currParams.id) {
          this.videoMode = true;
          this.loadedVideo = currParams.id;
        }
      } else {
        this.trainSvc.setApp('landing');
      }
      this.currentTab = this.trainSvc.currentApp();
      this.currentMode = this.currentTab === 'landing' ? 'landing' : 'course';
    });
    this.trainSvc.loadSettings();
    if (this.ss.get('currentApp') !== 'training')
      this.ss.set('currentApp', 'training');
    this.trainSvc.trainingData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(trainingRes => {
        this.settings = trainingRes;
        this.loading = false;
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  tabChange(videoCode?): void {
    this.loadedVideo = null;
    this.videoMode = false;
    this.currentTab = this.trainSvc.currentApp();
    this.currentMode = this.currentTab === 'landing' ? 'landing' : 'course';
    if (videoCode) {
      this.videoMode = true;
      this.loadedVideo = videoCode;
    }
  }
}
